import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    business: {
      title: 'For Businesses',
      links: [
        { name: 'Submit Business', href: '/submit-business' },
        { name: 'Advertise With Us', href: '/advertise' },
        { name: 'Promote Event', href: '/promote-event' },
        { name: 'Owner Dashboard', href: '/owner-dashboard' },
        { name: 'Pricing Plans', href: '/submit-business' }
      ]
    }
  };

  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img 
                src="https://static.readdy.ai/image/daa4d1286c7e40add692fc5e2a0b9f5f/593e1e03602cb23954036177d0cdac2a.png" 
                alt="Roseville.org" 
                className="h-10 w-auto object-contain"
              />
            </Link>
            <p className="text-gray-600 text-sm leading-relaxed">
              Your comprehensive guide to living, working, and thriving in Roseville, California.
            </p>
          </div>

          {/* Explore */}
          <div>
            <h3 className="text-lg font-bold text-gray-900 mb-4">Explore</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/directory" className="text-gray-600 hover:text-teal-600 transition-colors whitespace-nowrap">
                  Business Directory
                </Link>
              </li>
              <li>
                <Link to="/calendar" className="text-gray-600 hover:text-teal-600 transition-colors whitespace-nowrap">
                  Events Calendar
                </Link>
              </li>
              <li>
                <Link to="/deals" className="text-gray-600 hover:text-teal-600 transition-colors whitespace-nowrap">
                  Local Deals
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-gray-600 hover:text-teal-600 transition-colors whitespace-nowrap">
                  Local News
                </Link>
              </li>
              <li>
                <Link to="/weather" className="text-gray-600 hover:text-teal-600 transition-colors whitespace-nowrap">
                  Weather
                </Link>
              </li>
              <li>
                <Link to="/schools" className="text-gray-600 hover:text-teal-600 transition-colors whitespace-nowrap">
                  Schools
                </Link>
              </li>
              <li>
                <Link to="/parks" className="text-gray-600 hover:text-teal-600 transition-colors whitespace-nowrap">
                  Parks &amp; Trails
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Services</h3>
            <ul className="space-y-3">
              <li><Link to="/recreation" className="text-gray-600 hover:text-teal-600 text-sm transition-colors">Recreation</Link></li>
              <li><Link to="/real-estate" className="text-gray-600 hover:text-teal-600 text-sm transition-colors">Real Estate</Link></li>
              <li><Link to="/utilities" className="text-gray-600 hover:text-teal-600 text-sm transition-colors">Utilities</Link></li>
              <li><Link to="/transportation" className="text-gray-600 hover:text-teal-600 text-sm transition-colors">Transportation</Link></li>
              <li><Link to="/emergency" className="text-gray-600 hover:text-teal-600 text-sm transition-colors">Emergency Resources</Link></li>
              <li><Link to="/relocation" className="text-gray-600 hover:text-teal-600 text-sm transition-colors">Relocation</Link></li>
              <li><Link to="/jobs" className="text-gray-600 hover:text-teal-600 text-sm transition-colors">Jobs</Link></li>
              <li><Link to="/data-sources" className="text-gray-600 hover:text-teal-600 text-sm transition-colors">Data Sources</Link></li>
            </ul>
          </div>

          {/* Business */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Business</h3>
            <ul className="space-y-3">
              <li><Link to="/directory" className="text-gray-600 hover:text-teal-600 text-sm transition-colors">Directory</Link></li>
              <li><Link to="/submit-business" className="text-gray-600 hover:text-teal-600 text-sm transition-colors">List Your Business</Link></li>
              <li><Link to="/advertise" className="text-gray-600 hover:text-teal-600 text-sm transition-colors">Advertise</Link></li>
              <li><Link to="/deals" className="text-gray-600 hover:text-teal-600 text-sm transition-colors">Deals</Link></li>
              <li><a href="https://www.roseville.ca.us/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-teal-600 text-sm transition-colors">Government</a></li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Connect</h3>
            <div className="flex space-x-3 mb-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-teal-600 text-white flex items-center justify-center hover:bg-teal-700 transition-colors">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-teal-600 text-white flex items-center justify-center hover:bg-teal-700 transition-colors">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-teal-600 text-white flex items-center justify-center hover:bg-teal-700 transition-colors">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-teal-600 text-white flex items-center justify-center hover:bg-teal-700 transition-colors">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
            <ul className="space-y-3">
              <li className="flex items-start text-gray-600 text-sm">
                <i className="ri-phone-line text-teal-600 mr-2 mt-0.5"></i>
                <span>(916) 238-8515</span>
              </li>
              <li className="flex items-start text-gray-600 text-sm">
                <i className="ri-mail-line text-teal-600 mr-2 mt-0.5"></i>
                <span>info@roseville.org</span>
              </li>
              <li className="flex items-start text-gray-600 text-sm">
                <i className="ri-map-pin-line text-teal-600 mr-2 mt-0.5"></i>
                <span>5098 Foothills Blvd, Suite 3-402<br />Roseville, CA 95747</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-600 text-sm">
              © 2025 Roseville.org. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="/privacy" className="text-gray-600 hover:text-teal-600 text-sm transition-colors">Privacy Policy</a>
              <a href="/terms" className="text-gray-600 hover:text-teal-600 text-sm transition-colors">Terms of Service</a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-teal-600 text-sm transition-colors">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
